var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "u-width-full" }, [
    _c(
      "div",
      { staticClass: "u-flex u-flex-justify-end u-flex-justify-start@s" },
      [
        _vm.$root.user === false || _vm.community.isMember === false
          ? _c(
              "a",
              {
                class: ["c-btn", "c-btn--join-community"],
                attrs: { "data-cy": "join-community", href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.join.apply(null, arguments)
                  },
                },
              },
              [_c("p", [_vm._v("Join")])]
            )
          : _c(
              "a",
              {
                class: ["c-btn", "c-btn--invite"],
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.invite.apply(null, arguments)
                  },
                },
              },
              [_c("p", [_vm._v("Invite")])]
            ),
      ]
    ),
    _vm._v(" "),
    _c(
      "aside",
      {
        class: ["c-article__menu", { open: _vm.showContextMenu }],
        on: { click: _vm.toggleContextMenu },
      },
      [_vm._v(" ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { class: ["c-article__menu-items", { open: _vm.showContextMenu }] },
      [
        _c("ul", [
          _vm.community.isMember === false
            ? _c("li", [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.join.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Join Community")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.community.isMember && !_vm.community.isSubscribed
            ? _c("li", [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.subscribeToNotifications.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  },
                  [_vm._v("Enable Device Notifications")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.community.isMember && _vm.community.isSubscribed
            ? _c("li", [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.unsubscribeToNotifications.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  },
                  [_vm._v("Unsubscribe Device Notifications")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "community-copy-link",
                attrs: { href: "#", "data-link": "/" + _vm.community.url },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.copyUrl.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v("Copy the URL "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.copySuccess,
                        expression: "copySuccess",
                      },
                    ],
                  },
                  [_vm._v("✅")]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.community.isMember
            ? _c("li", [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.leave.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Leave Community")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.toggleContextMenu.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Cancel")]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }